import { Divider, Stack } from "@mui/material";

import { ExperimentTable } from "../experiment";
import { MissionTable } from "../mission";
import { SiteEditForm } from "./SiteEditForm";

export const SiteDetails = () => (
    <Stack spacing={2}>
        <SiteEditForm />
        <Divider />
        <ExperimentTable />
        <Divider />
        <MissionTable />
    </Stack>
);
